var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.75V5.5C2 5.1 2.15 4.75 2.45 4.45C2.75 4.15 3.1 4 3.5 4H20.5C20.9 4 21.25 4.15 21.55 4.45C21.85 4.75 22 5.1 22 5.5V9.75H20.5V5.5H3.5V9.75H2ZM3.5 20C3.1 20 2.75 19.85 2.45 19.55C2.15 19.25 2 18.9 2 18.5V14.25H3.5V18.5H20.5V14.25H22V18.5C22 18.9 21.85 19.25 21.55 19.55C21.25 19.85 20.9 20 20.5 20H3.5ZM9.99522 16.75C10.1317 16.75 10.2633 16.7167 10.39 16.65C10.5167 16.5833 10.6117 16.4833 10.675 16.35L14 9.7L15.325 12.35C15.3875 12.4833 15.4812 12.5833 15.6062 12.65C15.7312 12.7167 15.8625 12.75 16 12.75H22V11.25H16.475L14.675 7.675C14.613 7.5375 14.5199 7.44062 14.3958 7.38438C14.2716 7.32812 14.1413 7.3 14.0048 7.3C13.8683 7.3 13.7367 7.32812 13.61 7.38438C13.4833 7.44062 13.3883 7.5375 13.325 7.675L10 14.3L8.675 11.65C8.6125 11.5167 8.51875 11.4167 8.39375 11.35C8.26875 11.2833 8.1375 11.25 8 11.25H2V12.75H7.525L9.325 16.35C9.38705 16.4833 9.48013 16.5833 9.60425 16.65C9.72837 16.7167 9.85869 16.75 9.99522 16.75Z",
    fill: "current"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_85",
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D81C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExames);
export default __webpack_public_path__ + "static/media/exames.eb711cb10e4b0dd75f9d770b6451b989.svg";
export { ForwardRef as ReactComponent };